// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CentersModal_title__n4CrM {
  font-size: 1.8em;
  text-align: center;
  align-items: center;
  justify-content: center;
}

.CentersModal_main__iNokg {
  position: relative;
  background-color: #fff;
  padding: 20px 30px;
  padding-right: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: auto;
  width: 100%;
}
@media (min-width: 1023px) {
  .CentersModal_main__iNokg {
    max-height: calc(80vh - 67px);
  }
}
@media (min-width: 720px) {
  .CentersModal_main__iNokg {
    max-height: calc(80vh - 67px);
  }
}
@media (min-width: 320px) {
  .CentersModal_main__iNokg {
    max-height: calc(80vh - 67px);
  }
}
.CentersModal_main__iNokg .CentersModal_title__n4CrM {
  text-align: left;
  font-weight: 400;
}
.CentersModal_main__iNokg .CentersModal_titleContainer__QYjkR {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.CentersModal_main__iNokg .CentersModal_titleContainer__QYjkR .CentersModal_subtitle__ju848 {
  font-weight: 400;
}
.CentersModal_main__iNokg .CentersModal_subtitleContainer__h2u2x {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.CentersModal_main__iNokg .CentersModal_subtitleContainer__h2u2x .CentersModal_subtitle__ju848 {
  font-weight: 400;
}
.CentersModal_main__iNokg .CentersModal_container__WbAZR {
  overflow-y: scroll;
  padding-bottom: 80px;
  padding-right: 20px;
}
.CentersModal_main__iNokg .CentersModal_body__QOBf6 {
  margin-top: 20px;
}

.CentersModal_actions__k2ljl {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  padding: 10px;
  box-shadow: 0 -3px 3px #ddd;
}
.CentersModal_actions__k2ljl button {
  position: relative;
  z-index: 10;
  margin-left: auto;
  margin-right: auto;
  width: 80%;
}

.CentersModal_reducePadding__R7Wio {
  padding-left: 0;
}

.CentersModal_center__4ENWf {
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  justify-content: center;
}
.CentersModal_center__4ENWf button {
  margin-left: 5px;
  margin-right: 5px;
}

.CentersModal_grid__nfVOh {
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
@media (min-width: 320px) {
  .CentersModal_grid__nfVOh {
    flex-direction: column;
  }
}
@media (min-width: 480px) {
  .CentersModal_grid__nfVOh {
    flex-direction: column;
  }
}
@media (min-width: 720px) {
  .CentersModal_grid__nfVOh {
    flex-direction: row;
  }
}

.CentersModal_modal__N\\+4UO {
  animation: CentersModal_slide__cj9zA 0.8s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
}

@keyframes CentersModal_slide__cj9zA {
  0% {
    transform: translateY(200%);
  }
  100% {
    transform: translateY(0%);
  }
}
.CentersModal_remaining__O7nPA {
  font-size: 14px;
  font-weight: 300;
}`, "",{"version":3,"sources":["webpack://./src/dashboard/components/CentersModal/CentersModal.module.scss","webpack://./src/_common/scss/_colors.scss","webpack://./src/_common/scss/_media.scss","webpack://./src/_common/scss/_variables.scss"],"names":[],"mappings":"AAIA;EACE,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;AAHF;;AAMA;EACE,kBAAA;EACA,sBCSU;EDRV,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,YAAA;EACA,WAAA;AAHF;AEMI;EFZJ;IAYI,6BAAA;EAFF;AACF;AEHI;EFRJ;IAgBI,6BAAA;EADF;AACF;AEhBI;EFAJ;IAoBI,6BAAA;EAAF;AACF;AAEE;EACE,gBAAA;EACA,gBAAA;AAAJ;AAGE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AADJ;AAGI;EACE,gBAAA;AADN;AAKE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAHJ;AAKI;EACE,gBAAA;AAHN;AAOE;EACE,kBAAA;EACA,oBAAA;EACA,mBGxDQ;AHmDZ;AAQE;EACE,gBGvDO;AHiDX;;AAUA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,gBAAA;EACA,aAAA;EACA,2BAAA;AAPF;AASE;EACE,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;AAPJ;;AAWA;EACE,eAAA;AARF;;AAWA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;AARF;AAUE;EACE,gBAAA;EACA,iBAAA;AARJ;;AAYA;EACE,mBAAA;EACA,mBAAA;EACA,uBAAA;AATF;AExFI;EF8FJ;IAMI,sBAAA;EARF;AACF;AEzFI;EF0FJ;IAUI,sBAAA;EAPF;AACF;AE1FI;EFsFJ;IAcI,mBAAA;EANF;AACF;;AASA;EACE,qFAAA;AANF;;AASA;EACE;IACE,2BAAA;EANF;EASA;IACE,yBAAA;EAPF;AACF;AAUA;EACE,eAAA;EACA,gBAAA;AARF","sourcesContent":["@import '@common/scss/_colors';\n@import '@common/scss/_variables';\n@import '@common/scss/_media';\n\n.title {\n  font-size: 1.8em;\n  text-align: center;\n  align-items: center;\n  justify-content: center;\n}\n\n.main {\n  position: relative;\n  background-color: $filter-bg;\n  padding: $padding-l $padding-xl;\n  padding-right: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: auto;\n  width: 100%;\n\n  @include media(md) {\n    max-height: calc(80vh - $navbar-height);\n  }\n\n  @include media(sm) {\n    max-height: calc(80vh - $navbar-height);\n  }\n\n  @include media(xss) {\n    max-height: calc(80vh - $navbar-height);\n  }\n\n  & .title {\n    text-align: left;\n    font-weight: 400;\n  }\n\n  & .titleContainer {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n\n    & .subtitle {\n      font-weight: 400;\n    }\n  }\n\n  & .subtitleContainer {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n\n    & .subtitle {\n      font-weight: 400;\n    }\n  }\n\n  & .container {\n    overflow-y: scroll;\n    padding-bottom: 80px;\n    padding-right: $padding-l;\n  }\n\n  & .body {\n    margin-top: $margin-l;\n  }\n}\n\n.actions {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: #fff;\n  padding: 10px;\n  box-shadow: 0 -3px 3px #ddd;\n\n  button {\n    position: relative;\n    z-index: 10;\n    margin-left: auto;\n    margin-right: auto;\n    width: 80%;\n  }\n}\n\n.reducePadding {\n  padding-left: 0;\n}\n\n.center {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  align-items: center;\n  justify-content: center;\n\n  button {\n    margin-left: 5px;\n    margin-right: 5px;\n  }\n}\n\n.grid {\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n\n  @include media(xss) {\n    flex-direction: column;\n  }\n\n  @include media(xs) {\n    flex-direction: column;\n  }\n\n  @include media(sm) {\n    flex-direction: row;\n  }\n}\n\n.modal {\n  animation: slide 0.8s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;\n}\n\n@keyframes slide {\n  0% {\n    transform: translateY(200%);\n  }\n\n  100% {\n    transform: translateY(0%);\n  }\n}\n\n.remaining {\n  font-size: 14px;\n  font-weight: 300;\n}\n","$primary: var(--primary-color);\n$secondary: var(--secondary-color);\n$accent: var(--accent-color);\n$font-primary: var(--font-primary-color);\n$font-secondary: var(--font-secondary-color);\n$font-accent: var(--font-accent-color);\n$grey-100: #f4f5f7;\n$grey-200: #dbdbdb;\n$grey-300: #acacac;\n$grey-400: #838383;\n$chart-dataset-1: #df6767;\n$chart-dataset-2: #efa12c;\n$warning: orange;\n$error: #df6767;\n$white: #fff;\n$transparent: transparent;\n\n$primary-font-color: #fff;\n$secondary-font-color: #fff;\n$accent-font-color: #fff;\n$warning-font-color: #fff;\n$error-font-color: #fff;\n$filter-bg: #fff;\n\n$bg-main: var(--background-color);\n$card-bg: #fff;\n$default-control-bg: #fff;\n$card-shadow: 3px 3px 3px -1px rgba(0, 0, 0, 0.1);\n$default-shadow-color: rgba(0, 0, 0, 0.1);\n\n$default-border-color: #acacac;\n$default-backdrop-color: rgba(0, 0, 0, 0.8);\n\n$default-navbar-color: #fff;\n\n$stats-card-bg-color: #fff;\n$stats-card-color: #000;\n","// variables:\n$breakpoint-xss: 320px;\n$breakpoint-xs: 480px;\n$breakpoint-sm: 720px;\n$breakpoint-md: 1023px;\n$breakpoint-lg: 1360px;\n$breakpoint-xl: 1600px;\n\n@mixin media($media) {\n  // MOBILE FIRST\n  @if $media == xss {\n    @media (min-width: $breakpoint-xss) {\n      @content;\n    }\n  } @else if $media == xs {\n    @media (min-width: $breakpoint-xs) {\n      @content;\n    }\n  } @else if $media == sm {\n    @media (min-width: $breakpoint-sm) {\n      @content;\n    }\n  } @else if $media == md {\n    @media (min-width: $breakpoint-md) {\n      @content;\n    }\n  } @else if $media == lg {\n    @media (min-width: $breakpoint-lg) {\n      @content;\n    }\n  }\n}\n","@import './colors';\n\n$border-radius: 3px !default;\n$border-radius-extra: 8px !default;\n$padding-s: 5px;\n$padding-m: 10px;\n$padding-l: 20px;\n$padding-xl: 30px;\n$padding-xxl: 40px;\n$margin-s: 5px;\n$margin-m: 10px;\n$margin-l: 20px;\n$margin-xl: 30px;\n$margin-xxl: 40px;\n$margin-xxxl: 50px;\n$shadow-depth: 1;\n$base-font-size: 14px !default;\n$base-line-height: 17px !default;\n$base-unit: 'em' !default;\n$base-font-family: 'Source Sans Pro', sans-serif !default;\n$h1-font-size: 2 * $base-font-size !default;\n$h2-font-size: 1.5 * $base-font-size !default;\n$h3-font-size: 1.17 * $base-font-size !default;\n$h4-font-size: 1 * $base-font-size !default;\n$h5-font-size: 0.83 * $base-font-size !default;\n$h6-font-size: 0.67 * $base-font-size !default;\n$indent-amount: 40px !default;\n$normalize-vertical-rhythm: false !default;\n$default-border: solid 1px $default-border-color;\n$navbar-z-index: 10000;\n$top-most-z-index: 100000;\n$navbar-height: 67px;\n$navbar-bg: #d9d9d9;\n$default-navbar-shadow: 0 3px 3px -1px rgb(0 0 0 / 0.1);\n$default-statscard-shadow: 3px 3px 3px -1px rgb(0 0 0 / 0.1);\n$default-mainfilters-shadow: inset -3px 0 3px rgb(0 0 0 / 0.1);\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `CentersModal_title__n4CrM`,
	"main": `CentersModal_main__iNokg`,
	"titleContainer": `CentersModal_titleContainer__QYjkR`,
	"subtitle": `CentersModal_subtitle__ju848`,
	"subtitleContainer": `CentersModal_subtitleContainer__h2u2x`,
	"container": `CentersModal_container__WbAZR`,
	"body": `CentersModal_body__QOBf6`,
	"actions": `CentersModal_actions__k2ljl`,
	"reducePadding": `CentersModal_reducePadding__R7Wio`,
	"center": `CentersModal_center__4ENWf`,
	"grid": `CentersModal_grid__nfVOh`,
	"modal": `CentersModal_modal__N+4UO`,
	"slide": `CentersModal_slide__cj9zA`,
	"remaining": `CentersModal_remaining__O7nPA`
};
export default ___CSS_LOADER_EXPORT___;
